import { IPageAssetModel } from "../models/page.asset.model";
import { StringUtil } from "../utils/string-util";
import { IFontData } from "./font-data";

export type ILinkData = INoneLinkData | IUrlLinkData | IPageLinkData | IBookmarkLinkData | IDirectionLinkData | IEmailLinkData | IPhoneLinkData | IDocumentLinkData;

export interface ILinkFontData {
    font: IFontData;
    hoveredColor?: string;
    visitedColor?: string;
}

export interface IElementWithLink {
    linkData?: ILinkData;
}

export interface IElementWithTarget {
    target: LinkTargetType;
}

export interface INoneLinkData {
    type: "none";
    value: ""
}

export interface IUrlLinkData extends IElementWithTarget {
    type: "url"
    value: string;
}

export interface IDirectionLinkData {
    type: "top/bottom";
    value: string;
}

export interface IDocumentLinkData {
    type: "document";
    file: IPageAssetModel;
    value: string;
}

export interface IPageLinkData extends IElementWithTarget {
    type: "page";
    value: string;
}

export interface IBookmarkLinkData {
    type: "bookmark";
    value: string;
}

export interface IEmailLinkData {
    type: "email";
    value: string;
}

export interface IPhoneLinkData {
    type: "phone";
    value: string;
}

export class LinkData {

    public static get noneData(): ILinkData {
        return {
            type: "none",
            value: ""
        };
    }

    public static composeLinkData(link: string | null, target: LinkTargetType | null, file: IPageAssetModel | null): ILinkData {
        if (!link || link === "#") {
            return this.noneData;
        }

        if (file) {
            return {
                type: "document",
                value: link,
                file: file,
            };
        }

        if (link === "javascript:scroll(0,0)" || link === "javascript:scroll(0, document.body.scrollHeight)") {
            return {
                type: "top/bottom",
                value: link
            };
        }

        if (link.startsWith("mailto:", 0)) {
            return {
                type: "email",
                value: link
            };
        }

        if (link.startsWith("tel:", 0)) {
            return {
                type: "phone",
                value: link
            };
        }

        if (link.startsWith("http", 0) || link.startsWith("https", 0)) {
            return {
                type: "url",
                value: link,
                target: target ?? "_blank"
            };
        }

        if (link.includes("/#")) {
            return {
                type: "bookmark",
                value: link
            };
        }

        if (!StringUtil.isEmptyOrWhiteSpace(link)) {
            return {
                type: "page",
                value: link,
                target: target ?? "_blank"
            };
        }

        return this.noneData;
    }

    public static getTargetValueByLink(link: ILinkData): LinkTargetType {
        if (link.type === "url" || link.type === "page") return link.target;
        return "_self";
    }

}
export type LinkDataType = "none" | "url" | "page" | "bookmark" | "top/bottom" | "email" | "phone";

export type LinkTargetType = "_blank" | "_self";
